export default "__VITE_ASSET__glp4fDYe__"